import axios from "axios";
import label from "@/lang/StaticLabels.js";
const baseUrl = "base/api/v1/";
const saleUrl = "sale/api/v1/";
// تنظیمات زیرسیستم فروشگاهی و زیرسیستم غرفه؛ هر دو همان صفحه عمومی تنظیمات
const settingUrls = {
  shop: saleUrl + "basic/shop/Setting",
  booth: saleUrl + "basic/shop/BoothSetting",
};
// پیش فاکتور غرفه
const preOrderUrl = saleUrl + "operation/shop/PreOrder";
// فروشگاه و غرفه (سرویس بیس)
const storeUrl = baseUrl + "Store";
const boothUrl = baseUrl + "Booth";

export default {
  // Setting Actions ------------------------------------------------------------------
  // type: "shop" | "booth"
  getSetting({ dispatch, commit }, type) {
    commit("setSetting", []);
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(settingUrls[type])
      .then((res) => {
        commit("setSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  // data: { type, id, value }
  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(settingUrls[data.type] + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // DropDown Actions (سرویس بیس) ---------------------------------------------
  // غرفه‌های فعال؛ storeId اختیاری
  getBooths({ dispatch, commit }, storeId = null) {
    return axios
      .get(baseUrl + "DropDown/Booths" + (storeId ? "?storeId=" + storeId : ""))
      .then((res) => {
        commit("setBooths", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // فروشگاه‌های فعال شعبه
  getStoreOptions({ dispatch, commit }) {
    return axios
      .get(baseUrl + "DropDown/Stores")
      .then((res) => {
        commit("setStoreOptions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // کاربران عضو شعبه جاری به همراه شخص هر کاربر در شعبه
  getBranchUserPersons({ dispatch, commit }) {
    return axios
      .get(baseUrl + "DropDown/BranchUserPersons")
      .then((res) => {
        commit("setBranchUserPersons", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // پیش‌فرض‌های فروشگاه برای پر کردن پیش‌فرض‌های غرفه؛ دسترسی Store می‌خواهد
  getStoreDefaults({ dispatch }, id) {
    return axios
      .get(storeUrl + "/" + id)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },
  // پیش‌فرض‌های غرفه (سرپرست فروش، نوع فروش، سیاست قیمت‌گذاری، نوع تسویه) فقط در
  // جزئیات غرفه هست که دسترسی Booth می‌خواهد؛ کاربر غرفه ممکن است آن را نداشته
  // باشد، پس خطا بی‌صدا رد می‌شود و فرم بدون پیش‌فرض می‌ماند.
  getBoothDefaults({ dispatch }, id) {
    return axios
      .get(baseUrl + "Booth/" + id)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  // Store Actions - فروشگاه (سرویس بیس) -----------------------------------------
  // data: رشتهٔ کوئری فیلترها
  getStores({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(storeUrl + "?" + data)
      .then((res) => {
        commit("setStores", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getStoreById({ dispatch }, id) {
    return axios
      .get(storeUrl + "/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getStoreMaxCode({ dispatch }) {
    return axios
      .get(storeUrl + "/MaxCode")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  addStore({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(storeUrl, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editStore({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(storeUrl + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteStore({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(storeUrl, { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Booth Actions - غرفه (سرویس بیس) -----------------------------------------
  // data: رشتهٔ کوئری فیلترها
  getBoothList({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(boothUrl + "?" + data)
      .then((res) => {
        commit("setBoothList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBoothById({ dispatch }, id) {
    return axios
      .get(boothUrl + "/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getBoothMaxCode({ dispatch }) {
    return axios
      .get(boothUrl + "/MaxCode")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  addBooth({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(boothUrl, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSTOREBoothList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBooth({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(boothUrl + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSTOREBoothList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBooth({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(boothUrl, { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PreOrder Actions - پیش فاکتور غرفه ---------------------------------------------
  // data: رشتهٔ کوئری فیلترها (fromDate، toDate، boothId، personClubId، isCancel)
  getPreOrders({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(preOrderUrl + "?" + data)
      .then((res) => {
        commit("setPreOrders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPreOrderById({ dispatch, commit }, id) {
    commit("setPreOrderById", null);
    return axios
      .get(preOrderUrl + "/" + id)
      .then((res) => {
        commit("setPreOrderById", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // شماره بعدی فقط نمایشی است؛ شماره واقعی سمت سرور داده می‌شود
  getPreOrderMaxCode({ dispatch }) {
    return axios
      .get(preOrderUrl + "/MaxCode")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  // محاسبه یک سطر کالا (بدنه همان CalculateOrderQuery سفارش)
  calculatePreOrderCommodity({ dispatch }, data) {
    return axios
      .post(preOrderUrl + "/Calculate", data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  addPreOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(preOrderUrl, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSTOREPreOrderList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPreOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(preOrderUrl + "/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSTOREPreOrderList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePreOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(preOrderUrl, { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // انصراف (isCancel = true) یا برگشت انصراف (isCancel = false)
  // data: { id, isCancel, cancelReason }
  cancelPreOrder({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(preOrderUrl + "/" + data.id + "/Cancel", {
        isCancel: data.isCancel,
        cancelReason: data.cancelReason,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
